package com.damda.design_system.ui.views.core

import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.material3.windowsizeclass.WindowWidthSizeClass
import androidx.compose.material3.windowsizeclass.calculateWindowSizeClass
import androidx.compose.runtime.Composable
import com.damda.design_system.core.ImageResourceLoader

@Composable
expect fun MyApp(windowSize: ComposeWindowWidthSizeClass, imageResourceLoader: ImageResourceLoader)

enum class ComposeWindowWidthSizeClass {
    Small,
    Medium,
    Large
}

sealed class Screen {
    data object Home : Screen()
    data object Search : Screen()
    data object Profile : Screen()
    data class FoodDetail(val jsonString: String) : Screen()
}